/** Marine chart provider setup for BoatWise Chart Plotter. */

export const GARMIN_NAVIONICS_API_FORM =
  'https://www.garmin.com/en-US/forms/navionics-web-api/';

export const CHS_CHARTS_URL = 'https://www.charts.gc.ca/charts-cartes/catalogue/index-eng.html';
export const PARKS_TSW_NAV_URL = 'https://parks.canada.ca/lhn-nhs/on/trentsevern/visit/navigation';

/** Garmin / Navionics web chart viewer (opens in new tab). */
export function navionicsWebChartUrl(latitude, longitude, zoom = 14) {
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return 'https://maps.garmin.com/marine?maps=another-brand&overlay=false';
  }
  return `https://maps.garmin.com/marine?maps=another-brand&overlay=false#${zoom}/${latitude.toFixed(5)}/${longitude.toFixed(5)}`;
}

export const CMAP_DEVELOPER_URL = 'https://developer.c-map.com/';

export const CMAP_SETUP_STEPS = [
  'Register at C-MAP Developer Portal and create OAuth client credentials.',
  'Add CMAP_CLIENT_ID and CMAP_CLIENT_SECRET to Render → boatwise-api-beta → Environment.',
  'Redeploy — Chart Plotter uses C-MAP automatically on Trent-Severn and other inland waterways.',
];

export const NAVIONICS_SETUP_STEPS = [
  'Submit the Garmin Navionics Web API request form (Enhanced tier — required for vessel tracking overlay on charts).',
  'When approved, add NAVIONICS_WEB_API_KEY to Render → boatwise-api-beta → Environment.',
  'Redeploy — Chart Plotter loads Navionics charts automatically (Trent-Severn, Great Lakes, coast).',
];

export const CHART_INTEGRATION_PLAN = {
  primary: 'Navionics Web API (Garmin Enhanced tier)',
  fallbackCanada: 'CHS dynamic ENC where published + inland waterway map',
  fallbackUS: 'NOAA raster + VectorCharts (US token)',
};
